module.exports = __webpack_public_path__ + "media/images/shop/shop-cover2-838436caf7e7d75b34177aeb692acc8a.jpg";